/**
 * Country codes for onboarding / matching (ISO 3166-1 alpha-2).
 * Labels are English; UI can wrap with i18n later.
 */

export type PreferPartnerCountry = "same" | "any" | string;

/** Priority + common countries for the profile picker. */
export const COUNTRY_OPTIONS: { code: string; name: string }[] = [
  { code: "US", name: "United States" },
  { code: "CA", name: "Canada" },
  { code: "GB", name: "United Kingdom" },
  { code: "DE", name: "Germany" },
  { code: "FR", name: "France" },
  { code: "IT", name: "Italy" },
  { code: "ES", name: "Spain" },
  { code: "PT", name: "Portugal" },
  { code: "NL", name: "Netherlands" },
  { code: "CH", name: "Switzerland" },
  { code: "AT", name: "Austria" },
  { code: "PL", name: "Poland" },
  { code: "RO", name: "Romania" },
  { code: "UA", name: "Ukraine" },
  { code: "GR", name: "Greece" },
  { code: "BR", name: "Brazil" },
  { code: "MX", name: "Mexico" },
  { code: "CO", name: "Colombia" },
  { code: "AR", name: "Argentina" },
  { code: "CL", name: "Chile" },
  { code: "PE", name: "Peru" },
  { code: "PH", name: "Philippines" },
  { code: "KR", name: "South Korea" },
  { code: "CN", name: "China" },
  { code: "AU", name: "Australia" },
  { code: "NZ", name: "New Zealand" },
  { code: "NG", name: "Nigeria" },
  { code: "KE", name: "Kenya" },
  { code: "GH", name: "Ghana" },
  { code: "UG", name: "Uganda" },
  { code: "ZA", name: "South Africa" },
  { code: "ET", name: "Ethiopia" },
  { code: "CD", name: "DR Congo" },
  { code: "SE", name: "Sweden" },
  { code: "NO", name: "Norway" },
  { code: "DK", name: "Denmark" },
  { code: "FI", name: "Finland" },
  { code: "IE", name: "Ireland" },
  { code: "BE", name: "Belgium" },
  { code: "CZ", name: "Czechia" },
  { code: "HU", name: "Hungary" },
  { code: "ID", name: "Indonesia" },
  { code: "RU", name: "Russia" },
  { code: "TW", name: "Taiwan" },
  { code: "HK", name: "Hong Kong" },
  { code: "SG", name: "Singapore" },
  { code: "IN", name: "India" },
  { code: "JP", name: "Japan" },
];

const NAME_BY_CODE = Object.fromEntries(COUNTRY_OPTIONS.map((c) => [c.code, c.name]));

/** Cloudflare uses "XX" / "T1" when country is unknown. */
export function normalizeCountryCode(raw: string | null | undefined): string | null {
  if (!raw) return null;
  const code = raw.trim().toUpperCase();
  if (!code || code === "XX" || code === "T1" || code.length !== 2) return null;
  return code;
}

export function countryName(code: string | null | undefined): string {
  const n = normalizeCountryCode(code);
  if (!n) return "";
  return NAME_BY_CODE[n] ?? n;
}

/** Resolve preferred filter target country from self prefs. */
export function resolvePreferredCountry(
  selfCountry: string | null | undefined,
  preferred: PreferPartnerCountry | null | undefined
): string | null {
  if (!preferred || preferred === "any") return null;
  if (preferred === "same") return normalizeCountryCode(selfCountry);
  return normalizeCountryCode(preferred);
}
